export default __webpack_public_path__ + "static/process-4-c7277ec232b7a04ac1678d6ecd112f63.jpeg";